// extracted by mini-css-extract-plugin
module.exports = {"LogoText":"LogoText"};